import { render, staticRenderFns } from "./gonggao.vue?vue&type=template&id=408a8bca&scoped=true&"
import script from "./gonggao.vue?vue&type=script&lang=js&"
export * from "./gonggao.vue?vue&type=script&lang=js&"
import style0 from "./gonggao.vue?vue&type=style&index=0&id=408a8bca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408a8bca",
  null
  
)

export default component.exports